<script>
    import Icon from 'views/components/icon/Icon.svelte'

    export let icon = ''
    export let color = 'blue'
</script>

<div class="container {color}">
    {#if icon}
        <div class="icon">
            <Icon name={icon}></Icon>
        </div>
    {/if}

    <div class="content">
        <div class="title">
            <slot name="title"></slot>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  box-shadow: 0 10px 30px 0 rgba(18, 45, 64, 0.12);
  display: flex;
  border-radius: 12px;
  width: 100%;
  background: #fff;
  color: #122d40;
  --accent-color: hsl(205, 60%, 44%);
  border-left: 4px solid var(--accent-color);
}
.container .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0 12px 12px;
  align-self: stretch;
  border-radius: 12px 0 0 12px;
  flex-shrink: 0;
  fill: var(--accent-color);
}
.container .icon :global(svg) {
  height: 24px;
  width: 24px;
}
.container .content {
  font-size: 16px;
  padding: 12px 8px 12px 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.container .content .title {
  margin-bottom: 4px;
  font-weight: 600;
}
.container .content .title:empty {
  display: none;
}
.container .content :global(a) {
  color: hsl(205, 60%, 44%);
  text-decoration: none;
  cursor: pointer;
}
.container .content :global(a):hover {
  text-decoration: underline;
}
.container:has(.content .title:not(:empty)) .icon > :global(svg) {
  align-self: flex-start;
}
.container.red {
  --accent-color: #fc7787;
}
.container.orange {
  --accent-color: #ffa008;
}
.container.green {
  --accent-color: #3fd17d;
}

@media print {
  .container {
    box-shadow: none;
    background: none;
    border-radius: 0;
  }
}</style>
